import { gql } from '@apollo/client'

export const findAllBuyTOUGQL = gql`
  query findAllBuyTOU {
    findAllBuyTOU {
      _id
      name
      custId
    }
  }
`

export const UpdateBuyTOUGQL = gql`
  mutation updateBuyTOU($val: UpdateBuyTOUInput!) {
    updateBuyTOU(updateBuyTOUInput: $val) {
      _id
    }
  }
`
export const CreateBuyTOUGQL = gql`
  mutation createBuyTOU($val: CreateBuyTOUInput!) {
    createBuyTOU(createBuyTOUInput: $val) {
      _id
    }
  }
`
export const DeleteBuyTOUGQL = gql`
  mutation deleteBuyTOU($val: String!) {
    deleteBuyTOU(_id: $val) {
      _id
    }
  }
`

export const findOneBuyTOUGQL = gql`
  query findOneBuyTOU($val: String!) {
    findOneBuyTOU(_id: $val) {
      _id
      name
      custId
      cust {
        _id
        name
        facilityCapacity
        previousMethod
        revenueContractType
        contractPrice
        RECWeight
        pvOpt
      }
      planType
      powerMarketTransactionUnit
      touVer
      recYear
      recOpt
      recRegion
      smpYear
      holidayYear
      smpOpt
      timeTableOpt
      rateOpt
      flatAddEarnings
      sprAddEarnings
      sumAddEarnings
      fallAddEarnings
      winAddEarnings
      chargeUnitResult {
        spr {
          min
          mid
          max
        }
        sum {
          min
          mid
          max
        }
        fall {
          min
          mid
          max
        }
        win {
          min
          mid
          max
        }
      }
      touPeriodResult {
        spr {
          week
          sat
          holi
        }
        sum {
          week
          sat
          holi
        }
        fall {
          week
          sat
          holi
        }
        win {
          week
          sat
          holi
        }
      }
      sprMinMidRate
      sprMinMaxRate
      sumMinMidRate
      sumMinMaxRate
      fallMinMidRate
      fallMinMaxRate
      winMinMidRate
      winMinMaxRate
    }
  }
`

export const findAllKepcoTOUGQL = gql`
  query findAllKepcoTOU {
    findAllKepcoTOU {
      _id
      name
    }
  }
`

export const findPVDataGQL = gql`
  query findPVData($val: String!) {
    findPVData(_id: $val) {
      date
      value
    }
  }
`

export const getHolidaysGQL = gql`
  query getHolidays($val: String!) {
    getHolidays(selectedYear: $val) {
      year
      data {
        locdate
        dateName
      }
    }
  }
`

export const getRECGQL = gql`
  query findAllREC($val: String!) {
    findAllREC(year: $val) {
      year
      data {
        date
        landAvgPrc
        jejuAvgPrc
      }
    }
  }
`

export const findOneKepcoTOUGQL = gql`
  query findOneNameKepcoTOU($val: String!) {
    findOneNameKepcoTOU(name: $val) {
      _id
      name
      kepcoTOUPeriodId
      kepcoTOUPeriod {
        _id
        touPeriods {
          spr {
            week
            sat
            holi
          }
          sum {
            week
            sat
            holi
          }
          fall {
            week
            sat
            holi
          }
          win {
            week
            sat
            holi
          }
        }
      }
      data {
        name
        defaultChargeUnit
        chargeUnit {
          spr {
            min
            mid
            max
          }
          sum {
            min
            mid
            max
          }
          fall {
            min
            mid
            max
          }
          win {
            min
            mid
            max
          }
        }
      }
    }
  }
`

export const findLatestKepcoTOUPlanGQL = gql`
  query findLatestKepcoTOUPlan($planName: String!) {
    findLatestKepcoTOUPlan(planName: $planName) {
      versionName
      effectiveDateText
      data {
        name
        defaultChargeUnit
        chargeUnit {
          spr {
            min
            mid
            max
          }
          sum {
            min
            mid
            max
          }
          fall {
            min
            mid
            max
          }
          win {
            min
            mid
            max
          }
        }
      }
    }
  }
`
export const findAllKepcoTOUperiod = gql`
  query {
    findAllKepcoTOUPeriod {
      _id
      touPeriods {
        spr {
          week
          sat
          holi
        }
        sum {
          week
          sat
          holi
        }
        fall {
          week
          sat
          holi
        }
        win {
          week
          sat
          holi
        }
      }
    }
  }
`
export const getSMPGQL = gql`
  query findSmpByYear($val: String!) {
    findSmpByYear(year: $val) {
      _id
      year
      data {
        date
        value
        maxSmp
        minSmp
        weightedAver
      }
    }
  }
`
